import { createFileRoute } from '@tanstack/react-router';
import { CalendarView } from '@/features/calendar/calendar-view';
import { parseCalendarSearch, withCalendarTask } from '@/features/calendar/calendar-search';
import { requireCalendarFeature } from '@/features/calendar/guard';
import { useProject } from '@/features/projects/use-project';
import { TaskPanel } from '@/features/tasks/task-panel';

/** TASK-10: calendar of a project; view, date and filters in the URL, `?task=KEY-1` opens the panel. */
export const Route = createFileRoute('/_app/p/$projectKey/calendar')({
  validateSearch: (raw: Record<string, unknown>) => parseCalendarSearch(raw),
  beforeLoad: ({ context }) => requireCalendarFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const project = useProject(projectKey);
  const linkTo = (key: string) => ({
    to: '/p/$projectKey/calendar' as const,
    params: { projectKey: project.key },
    search: withCalendarTask(search, key),
  });
  return (
    <>
      <CalendarView
        project={project}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
        linkTo={linkTo}
      />
      <TaskPanel
        projectKey={project.key}
        taskKey={search.task}
        linkTo={linkTo}
        onTaskChange={(key, options) => {
          void navigate({
            search: withCalendarTask(search, key),
            replace: options?.replace === true,
          });
        }}
      />
    </>
  );
}
